import { render, staticRenderFns } from "./BannerVerbalIdentityImageSection.vue?vue&type=template&id=ecfb88ec"
import script from "./BannerVerbalIdentityImageSection.vue?vue&type=script&lang=ts"
export * from "./BannerVerbalIdentityImageSection.vue?vue&type=script&lang=ts"
import style0 from "./BannerVerbalIdentityImageSection.vue?vue&type=style&index=0&id=ecfb88ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports